import InSpectionPoints from '../../../components/vehicle/inspection_points'
import InSpectionPointsStore from '../../../components/vehicle/inspection_points/context/context'

const InSpectionPointsPage = (props) => {
  return (
    <InSpectionPointsStore>
      <InSpectionPoints />
    </InSpectionPointsStore>
  )
}

export default InSpectionPointsPage
